// The saved settings name a token, an account and a property by id, and any of the three can have
// gone away: access to a property can be revoked in Google, and re-consenting mints a new token
// name, which leaves every workspace saved before it naming a token that no longer exists. The
// connection behind that token is the same Google account, which the settings also record, so the
// account is what the token falls back to. The account and the property can only be matched once the
// account summaries have been fetched. Whatever cannot be matched is left out, and the dialog shows
// that select empty.
export function savedSelection(settings, analyticsTokens = [], accountSummaries = []) {
    const token = matchingToken(settings, analyticsTokens);
    if (!token) return {};

    const summary = accountSummaries.find(candidate => candidate.account.name === "accounts/" + settings.accountId);
    if (!summary) return { token };

    const property = (summary.properties || []).find(candidate => candidate.name === "properties/" + settings.propertyId);
    return { token, summary, property };
}

function matchingToken(settings, analyticsTokens) {
    const named = analyticsTokens.find(candidate => candidate.name === settings.tokenName);
    if (named || !settings.analyticsAccountOwner) return named;

    return analyticsTokens.find(candidate => candidate.analyticsAccountOwner === settings.analyticsAccountOwner);
}
